import axios from 'axios'
import qs from 'qs'
import router from '@/router'
import { Notify, Dialog } from 'vant'
import store from '../store'
import { getToken } from '@/utils/auth'
import Config from '@/config'

// 创建axios实例
const service = axios.create({
  // 正式环境
  // baseURL: process.env.VUE_APP_API_URL, 
  // 测试环境
  baseURL: process.env.BASE_API, 
  timeout: Config.timeout // 请求超时时间
})




// request拦截器
service.interceptors.request.use(
  config => {
    if (getToken() && config.url.indexOf('cus/') < 0) {
      config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // if (config.method === 'get') {
    //  config.paramsSerializer = function(params) {
    //    qs.stringify(params, { arrayFormat: 'repeat' })
    //  }
    // }
    if (!config.headers) config.headers['Content-Type'] = 'application/json'
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    const code = response.status

    if (code < 200 || code > 300) {
      Notify({
        type: 'danger',
        message: response.message
      })
      return Promise.reject('error')
    } else {

      return response.data
    }
  },
  error => {
    let code = 0
    try {
      code = error.response.status

    } catch (e) {
      if (error.toString().indexOf('Error: timeout') !== -1) {
        Notify({
          type: 'danger',
          message: '网络请求超时',
          duration: 2500
        })
        return Promise.reject(error)
      }
      if (error.toString().indexOf('Error: Network Error') !== -1) {
        Notify({
          type: 'danger',
          message: '网络请求错误',
          duration: 2500
        })
        return Promise.reject(error)
      }
    }
    if (code === 401) {
      Dialog.confirm({
        title: '系统提示',
        message: '登陆已过期，请重新登陆',
        theme: 'round-button'
      }).then(() => {
        store.dispatch('LogOut').then(() => {
          router.push({
            name: 'login'
          })
          // location.reload() 
          window.location.href = "https://wx.xchengtech.cn/saas/getOpenId?destination=code&depName=xc&url=http%3A%2F%2Fxccompanyrepo.xchengtech.cn%2F%23%2FbesoReport" // 为了重新实例化vue-router对象 避免bug
        })
      })
    } else if (code === 403) {
      //router.push({ path: '/401' })
    } else {

      const errorMsg = error.response.data.message
      if (errorMsg !== undefined) {
        Notify({
          type: 'danger',
          message: errorMsg,
          duration: 2500
        })
      }
    }
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js